import React from 'react';
import styled, { keyframes } from 'styled-components';
import PrizeTable from './prizeTable';

// Fade-in animation
const fadeInUp = keyframes`
    0% {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
`;

// Overlay that dims the background
const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
`;

const ModalContent = styled.div`
    position: relative;
    width: 90%;
    max-width: 400px;
    max-height: 80%;
    background: transparent;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;



    @media (max-width: 500px) {
        width: 90%;
    }
`;

// Visual card wrapper with background, border, shadow
const CardWrapper = styled.div`
    background-color: #FFE73A;
    border: 4px solid #F9FBFC;
    border-radius: 20px;
    color: white;
    text-align: center;
    box-shadow: 0 0 0 4px #E4B800, 0 0 0 8px #d0d7ff;
    position: relative;
    z-index: 1;
    padding: 60px 25px 25px 25px;
    width: 100%;
    overflow-y: auto; /* Enable vertical scrolling if content exceeds max height */
max-height: 70%;

    h2 {
        margin-bottom: 15px;
        font-size: 26px;
    }

    p {
        text-align: left;
        font-size: 16px;
    }

    img {
        width: 100%;
        height: auto;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    @media (max-width: 500px) {
        padding: 50px 20px 20px 20px;
    }
`;

// Title image placed above the card
const TitleImage = styled.img`
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    z-index: 2;
    pointer-events: none;
`;

// Close icon (optional)
const CloseIcon = styled.img`
    width: 35px;
    height: 35px;
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
    z-index: 3;
`;

interface ModalProps {
    onClose: () => void;
}

export const LeaderboardModal: React.FC<ModalProps> = ({ onClose }) => {
    return (
        <Overlay>
            <ModalContent>
                <TitleImage src="./leaderboard-title.svg" alt="Leaderboard" />
                {/* Optional close icon */}
                <CloseIcon src="./crossx.png" alt="Close" onClick={onClose} />
                <CardWrapper>
                    <PrizeTable />
                </CardWrapper>
            </ModalContent>
        </Overlay>
    );
};
